module.exports = __webpack_public_path__ + "img/a9.5bc0ce0d.png";